module.exports = __webpack_public_path__ + "assets/img/dynamic.dc8bd77c.svg";